import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const ViewContext = createContext(null);

export const ViewProvider = ({ children }) => {
  const { user } = useAuth();
  const [activeView, setActiveView] = useState('admin'); // 'admin' ou 'user'

  // Charger la préférence depuis localStorage au montage
  useEffect(() => {
    const savedView = localStorage.getItem('activeView');
    if (savedView && (savedView === 'admin' || savedView === 'user')) {
      setActiveView(savedView);
    } else if (user) {
      // Par défaut, si l'utilisateur a le rôle admin, on affiche l'interface admin
      const defaultView = user.roles?.includes('admin') || user.role === 'admin' ? 'admin' : 'user';
      setActiveView(defaultView);
    }
  }, [user]);

  // Sauvegarder la préférence dans localStorage quand elle change
  const switchView = (view) => {
    if (view === 'admin' || view === 'user') {
      setActiveView(view);
      localStorage.setItem('activeView', view);
    }
  };

  // Vérifier si l'utilisateur peut accéder à une vue spécifique
  const canAccessView = (view) => {
    if (!user) return false;
    
    if (view === 'admin') {
      return user.roles?.includes('admin') || user.roles?.includes('super_admin') || 
             user.role === 'admin' || user.role === 'super_admin';
    }
    
    if (view === 'user') {
      return user.roles?.includes('user') || user.role === 'user';
    }
    
    return false;
  };

  // Vérifier si l'utilisateur a accès aux deux interfaces
  const hasMultipleViews = () => {
    if (!user) return false;
    const roles = user.roles || (user.role ? [user.role] : []);
    const hasAdmin = roles.includes('admin') || roles.includes('super_admin');
    const hasUser = roles.includes('user');
    return hasAdmin && hasUser;
  };

  return (
    <ViewContext.Provider
      value={{
        activeView,
        switchView,
        canAccessView,
        hasMultipleViews,
      }}
    >
      {children}
    </ViewContext.Provider>
  );
};

export const useView = () => {
  const context = useContext(ViewContext);
  if (!context) {
    throw new Error('useView must be used within a ViewProvider');
  }
  return context;
};
